import { render, staticRenderFns } from "./ProductFeatureList.vue?vue&type=template&id=5c49b895&scoped=true&"
import script from "./ProductFeatureList.vue?vue&type=script&lang=js&"
export * from "./ProductFeatureList.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeatureList.vue?vue&type=style&index=0&id=5c49b895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c49b895",
  null
  
)

export default component.exports